import { useMemo } from "react";
import { useMutation } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useSessionJWT, useSessionCtx } from "utils";
import { makeGetDepositCalculations } from "./";

export default function useGetDepositCalculations() {
  const { formatMessage } = useIntl();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  const getDepositCalculations = useMemo(
    () => makeGetDepositCalculations(formatMessage),
    [formatMessage]
  );

  return useMutation({
    mutationFn: ({ paymentMethodId, amount }) => getDepositCalculations(ctx, paymentMethodId, amount)
  });
}
